import { useHomeViewModel } from './home.viewModel';
import { registerContext } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { HomeView } from './Home.view';

export const homeVM = registerContext('homeVM', useHomeViewModel);

export const HomePage = (p: { params: { influencerId?: string } }) => {
  return (
    <homeVM.ValueProvider
      params={p.params}
      renderer={(vm) => <HomeView {...vm} />}
    />
  );
};
